import { IconName, LockIcon } from '@ardoq/icons';
import { IconButton } from '@ardoq/button';
import { DEFAULT_ARDOQ_I18NLOCALE, type I18nLocale, t } from '@ardoq/i18n';

type DeleteRefererences = {
  isLocked: boolean;
  readonly: boolean;
  preventReferenceModification: boolean;
  i18nLocale?: I18nLocale;
  deleteReference: () => void;
};

const getTooltipText = (
  i18nLocale: I18nLocale,
  isLocked: boolean,
  readonly: boolean
): string => {
  if (isLocked) {
    return t(
      i18nLocale,
      'surveysUi:reference.lockedTooltip',
      'This reference has been locked and cannot be deleted or edited.'
    );
  }
  if (readonly) {
    return t(
      i18nLocale,
      'surveysUi:reference.readonlyTooltip',
      'This reference has been marked as read-only in the context of this survey and cannot be deleted or edited.'
    );
  }
  return t(
    i18nLocale,
    'surveysUi:reference.preventModificationTooltip',
    'References have been marked as edit-only in the context of this survey and cannot be added or deleted.'
  );
};

export const DeleteReferenceButton = ({
  isLocked,
  readonly,
  preventReferenceModification,
  i18nLocale = DEFAULT_ARDOQ_I18NLOCALE,
  deleteReference,
}: DeleteRefererences) => {
  if (isLocked || readonly || preventReferenceModification) {
    return (
      <LockIcon
        data-tooltip-text={getTooltipText(i18nLocale, isLocked, readonly)}
      />
    );
  }
  return (
    <IconButton
      label={t(i18nLocale, 'surveysUi:reference.deleteLabel', 'Delete')}
      iconName={IconName.DELETE}
      onClick={deleteReference}
      data-test-id="delete-reference-button"
    />
  );
};
